var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.75037 41.6853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.63226,4.79346H15.79303V0H120.92365V4.79346h-8.83911V37.01489c-.90936-.05786-1.82672-.11426-2.75488-.16821V4.79346h-25.47772v31.10352c-.91376-.01636-1.83185-.03149-2.75464-.04468V4.79346h-25.47772v31.12891c-.92249,.01855-1.84235,.0376-2.75488,.05957V4.79346H27.38702V37.09814c-.92865,.06177-1.84717,.125-2.75476,.19043V4.79346Zm45.74286,32.17773c-32.09302,0-59.49762,1.95679-70.37512,4.71411,16.2182-1.31934,40.87738-2.47559,70.37512-2.47559s55.17487,1.21411,70.37524,2.47559c-10.87756-2.75732-38.28223-4.71411-70.37524-4.71411Z",
    fill: "#00204e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailIcon);
export default __webpack_public_path__ + "static/media/rail-icon.fec0eb67e74c01199de10a8c9c39b84e.svg";
export { ForwardRef as ReactComponent };